import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IGetRedditSubmissionsData, RedditSubmissionsPaginationResponse } from '../Models/IRedditPost';
import { IRedditSubmissionDetailsPutDto } from '../Models/IRedditPostDetailsPutDto';
import { IRedditUpdateSubmissionStatusDto } from '../Models/IRedditUpdateSubmissionStatusDto';
import { IRedditComment } from '../Models/IRedditComment';
import { RedditPoliticianDto } from '../Models/IRedditPolitician';
import { IFilterBody, IApiResponseDto, IPagination, ITopic} from '../../../helpers/general.interface';
import { HelperFunctions } from '../../../helpers/HelperFunctions';


@Injectable({
  providedIn: 'root'
})
export class RedditService {
  constructor(private http: HttpClient) {}

  public getAllSubmissions(pagination: IPagination, sortBy: string, sortDir: string, searchVal: string, filters: IFilterBody[]): Observable<RedditSubmissionsPaginationResponse> {
    let params: HttpParams = new HttpParams();
    

    if (pagination) {
      params = HelperFunctions.addPaginationToParams(params, pagination);
    }
    
    if (sortBy)
      params = params.set('sortBy', sortBy);

    
    if (sortDir)
      params = params.set('sortDir', sortDir);
    
    if (searchVal)
      params = params.set('searchVal', searchVal);
    
    return this.http.post<RedditSubmissionsPaginationResponse>(
      `${environment.redditUrl}/Submission/list`, filters || [], { params: params }
    );
  }

   public updateSubmissionDetails(body: IRedditSubmissionDetailsPutDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.redditUrl}/Submission`, body)
    return response
   }

  public updateSubmissionStatus(body: IRedditUpdateSubmissionStatusDto): Observable<IApiResponseDto> {
    let response: Observable<IApiResponseDto> = this.http.put<IApiResponseDto>(`${environment.redditUrl}/Submission/update-status`, body)
    return response
   }


   public getSubmissionDetails(id: number): Observable<IGetRedditSubmissionsData> {
    return this.http.get<IGetRedditSubmissionsData>(`${environment.redditUrl}/Submission/${id}`);
  }
  


   public getSubmissionComments(id: number): Observable<IRedditComment> {

    let response: Observable<IRedditComment> = this.http.get<IRedditComment>(`${environment.redditUrl}/Submission/${id}/comments`)
    return response
   }

   public getCommentDetails(id: number): Observable<IRedditComment> {

    let response: Observable<IRedditComment> = this.http.get<IRedditComment>(`${environment.redditUrl}/Comment/${id}`)
    return response
   }


   public getPoliticians(): Observable<RedditPoliticianDto> {
    let response = this.http.get<RedditPoliticianDto>(`${environment.redditUrl}/Politician/list`);
    return response;
   }

   public getSubmissionTopics(): Observable<ITopic> {

    let response: Observable<ITopic> = this.http.get<ITopic>(`${environment.redditUrl}/topic/list`)
    return response
   }
}